export const orgId = JSON.parse(sessionStorage.getItem('user'))?.org?.id